
export default {
    main:{
        home: 'Home',
        guided_tour: 'Guided tour',
        menber: 'Menber',
        my: 'Menber',

        overview: 'Overview',
        serve: 'Serve',
        reality: 'Reality',
        map: 'Map',
        facilities: 'Facilities',
        audio: 'Audio',
        search: 'Search',
        my_position: 'My position',
        recommended_routes: 'Recommended routes',
        play_route: 'Play route',
        go_here: 'Go here',
        listen_on_go: 'Listen on go',

        spots_search_placeholder: 'Please enter the scenic spots and public facilities you want to search for',
        spots_detail: 'Scenic spot details',
        whole: 'whole',
        hours: ' hours',
        check: 'check',
        hide: 'hide',
        recommend: 'recommend',
        '个景点': ' attractions',
        '公里': 'kilometer',
        '小时': ' hours',
        '上划查看路线介绍': 'Draw up to view the route introduction',
        '去这里': 'Go here',
        '选择语言': 'Choose language',
        '营业时间': 'business hours',
        '地址': 'address',
        '电话': 'phone',
        '详情': 'details',
        '语音讲解': 'Voice explanation',
        '暂停': 'suspend',
        '继续': 'continue',
        '到这里去': 'Go here',
        '视频讲解': 'Video explanation',
        '距您': 'distance',
        '走到景点附近自动播放语音讲解': 'Automatically play voice explanations when walking near scenic spots',
        '关闭边走边听': 'Turn off listening while walking',
        '浏览器阻止了定位操作！': 'The browser has blocked the location operation!',
        '无法获得当前位置！': 'Unable to obtain current location!',
        '定位超时！': 'Positioning timeout!',
        '没有找到相关数据哦！': 'No relevant data found!',
        '查看详情': 'Detail',
        '请开启蓝牙服务以便使用边走边听': 'Please enable Bluetooth service for use while walking and listening',
        '请开启位置服务以便使用边走边听': 'Please enable location service for use while walking and listening',
        '系统或设备不支持蓝牙定位': 'The system or device does not support Bluetooth positioning',
        '系统错误': 'system error',

        '当前不在景区范围内！': 'Currently not in the scenic area!',

        '步行': 'walk',
        '开车': 'drive',
        '坐船': 'by boat',
        '骑行': 'ride',

        '景点设施': 'Scenic facilities',
        '返回': 'Return',
        '展开查看': 'Expand View',
        '收起': 'Retract',
        '路线介绍': 'Route Introduction',
        '查看地图': 'View Map',
        '路线详情': 'Route Details',

        '室内': 'indoor',
        'AR导航': 'AR navigation',
    }
}